import { COLOR_TYPE } from '@shared/models/enums/theme'
import { sidebarDataProvider } from '@shared/plugins/sidebar'
import { genMixColor } from '@shared/utils/helpers/theme/getMixColor'

const setStyleProperty = (propName: string, value: string) => {
  document.documentElement.style.setProperty(propName, value)
}

export const updateTheme = (color: string, name: string) => {
  const { DEFAULT, dark, light } = genMixColor(color)
  setStyleProperty(`--el-color-${name}`, DEFAULT)

  setStyleProperty(`--${name}-lighter-color`, light[5])
  setStyleProperty(`--${name}-light-color`, light[3])
  setStyleProperty(`--${name}-color`, DEFAULT)
  setStyleProperty(`--${name}-deep-color`, dark[2])
  setStyleProperty(`--${name}-deeper-color`, dark[4])

  setStyleProperty(`--el-color-${name}-dark-2`, dark[2])
  setStyleProperty(`--el-color-${name}-light-3`, light[3])
  setStyleProperty(`--el-color-${name}-light-5`, light[5])
  setStyleProperty(`--el-color-${name}-light-7`, light[7])
  setStyleProperty(`--el-color-${name}-light-8`, light[8])
  setStyleProperty(`--el-color-${name}-light-9`, light[9])
}
// hash color
export const initTheme = (color?: string) => {
  /** @description
   *
   * This function is used to initialize the theme of the application. It is called when the application is loaded.
   * example:
   * */

  const { primaryColor } = sidebarDataProvider()
  if (color) {
    updateTheme(color, COLOR_TYPE.PRIMARY)
    return
  }
  if (primaryColor) {
    updateTheme(`#${primaryColor}`, COLOR_TYPE.PRIMARY)
  }

  /* eslint-disable no-console */
  console.log('Theme is initialized!')
}
